// NOTICE: KAPTION-INTEGRATION
// whatsapp-calling.WEB.3 — the Calls workspace. Views: all, missed, waiting
// (call permission requested). The page itself renders a "not enabled" state
// while KAPTION_WHATSAPP_CALLING is off, rather than a route guard that could
// bounce the agent on a cold flag cache.
import { frontendURL } from '../../../helper/URLHelper';

const KaptionCallsPage = () => import('./KaptionCallsPage.vue');

export const KAPTION_CALLS_ROUTE = 'kaption_calls';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/calls/:view(all|missed|waiting)?'),
    name: KAPTION_CALLS_ROUTE,
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
    component: KaptionCallsPage,
  },
];
